module.exports = __webpack_public_path__ + "img/MORE pasta pizza.a7f0454b.svg";